export class Utilitarios{
    public static WAIT_TIME: number = 60000;
    public static NEXT_LEVEL: string = null;

    public static substituirCaracteresEspeciais(text: string): string{
        var parsed = text?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return parsed;
    }

    public static millisecondsToTime(milliseconds) {
        // Pad to 2 or 3 digits, default is 2
        let pad = function(n: any, z: any) {
          z = z || 2;
          return ('00' + n).slice(-z);
        }
    
        let ms = milliseconds % 1000;
        milliseconds = (milliseconds - ms) / 1000;
        let secs = milliseconds % 60;
        milliseconds = (milliseconds - secs) / 60;
        let mins = milliseconds % 60;
        let hrs = (milliseconds - mins) / 60;
    
        return pad(hrs, null) + ':' + pad(mins, null) + ':' + pad(secs, null);
    }

    public static tentativasLimiteBloqueio(tentativa: number, callBack: any = null, limite: number = 3, time: number = 2000): number
    {
        limite = 10000;
        tentativa++;
        
        if(tentativa>=limite){
            if(callBack)
            {
                setTimeout(function(){ callBack(); }.bind(this), time);
            }
        }

        return tentativa;
    }

    public static titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        return splitStr.join(' '); 
     }

    public static formataCPF(cpf): string{
        //retira os caracteres indesejados...
        cpf = cpf.replace(/[^\d]/g, "");
    
        //realizar a formatação...
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    public static formataCelularDDD(celular): string{
        celular=celular.replace(/\D/g,""); //Remove tudo o que não é dígito
        celular=celular.replace(/^(\d{2})(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
        celular=celular.replace(/(\d)(\d{4})$/,"$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos
        return celular;
    }

    public static getDate(): string {
        var date = new Date();
        return date.toLocaleDateString("pt-br");
    }

    public static getTime(): string {
        var date = new Date();
        return [date.getHours(), date.getMinutes(), date.getSeconds()]
            .map(current => current >= 10 ? current : "0" + current).join(":");
    }

    public static addHours(date: Date, qtdHours: number) {
        date.setTime(date.getTime() + (qtdHours*60*60*1000));
        return date;
    }

    public static addMinutes(date: Date, qtdMinutes: number) {
        return new Date(date.getTime() + qtdMinutes*60000);
    }
}